import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const CustomerImportRoutes = defineRoute({
    upload: {
        route: {
            path: "/customer-import/upload",
            component: () => loadView(import("./CustomerImportUpload.vue")),
        },
    },
    record: {
        route: {
            path: "/customer-import",
            component: () => loadView(import("./CustomerImportTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/customer-import/detail/:id",
            component: () => loadView(import("./CustomerImportDetail.vue")),
        },
        build(id: string) {
            return `/customer-import/detail/${id}`;
        },
    },
});
